export default __webpack_public_path__ + "static/media/hero-shoppinglist.166173fe.png";